import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import AuthDispatcher from "../redux/dispatch/AuthDispatcher";

const SessionWrapper = ({ children }) => {
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    AuthDispatcher.setSession(auth);
  }, []);

  return <React.Fragment>{children}</React.Fragment>;
};

export default SessionWrapper;
